// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"CR-z","inlineTitle":"DR-z","sponsoredAdsWrapper":"ER-z","marketplaceRecosWrapper":"FR-z"};